import React from "react";
import { Tooltip, TooltipProps } from "@material-ui/core";
import useStyles from "./styles";


interface DPTooltipProps extends TooltipProps {
  width?: number;
}

const DPTooltip = (props: DPTooltipProps) => {
  const classes = useStyles({ width: props.width });

  return (
    <Tooltip
      classes={{
        tooltip: classes.tooltip
      }}
      {...props}
    />
  );
};

export default DPTooltip;
